import React from 'react';

import PhoneNumberSelect from '@components/Share/PhoneNumberSelect';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Global from '@utils/global';

import { useVerifyPhoneNumberUpdate } from './index';

export const PhoneNumberInput = () => {
  const { settingGlobal, formikValues, formikErrors, formikTouched, fieldPhoneCode, inputData, verifyOtpErrorMsg, setFieldValue } =
    useVerifyPhoneNumberUpdate();

  const onHandleTelephoneChange = (evt, fieldName) => {
    let telephone = evt.target.value;

    /** INFO: save phone value into formik values */
    if (!telephone || new RegExp(settingGlobal.PhoneNumberFormat).test(telephone)) {
      setFieldValue(fieldName, telephone);
    }
  };

  const handleSelectPhoneCode = (code) => {
    fieldPhoneCode.current.code = code;

    setFieldValue('phoneCode', code);
  };

  return (
    <div
      className={[
        settingGlobal?.UseAreaCode
          ? `${Global.renderDynamicClass(
            formikErrors.phone && formikTouched.phone,
            'form-group',
            'input-error-validate'
          )} form-group--group-select-input`
          : Global.renderDynamicClass(formikErrors.phone && formikTouched.phone, 'form-group', 'input-error-validate')
      ].join(' ')}
    >
      {settingGlobal?.UseAreaCode ? (
        <PhoneNumberSelect
          setPhoneNumberCodeEvt={handleSelectPhoneCode}
          optionValues={settingGlobal.AreaCodes}
          currentValue={fieldPhoneCode.current.code}
        />
      ) : (
        ''
      )}
      <div className='form-group--input'>
        <input
          type='text'
          id='phone'
          onChange={(evt) => onHandleTelephoneChange(evt, 'phone')}
          value={formikValues.phone}
          className={Global.renderDynamicClass(formikValues['phone'], 'form-control form-control-lg', 'input-valid')}
          name='phone'
          placeholder={inputData['Phone Number Label'].value}
        />
        <label htmlFor='phone' className='form-group__label'>
          <Text field={inputData['Phone Number Label']} />
        </label>
        {formikErrors?.phone && formikTouched?.phone ? <span className='error-validate'>{formikErrors?.phone}</span> : <></>}
        {formikErrors?.otp && formikTouched?.otp ? <span className='error-validate'>{formikErrors?.otp}</span> : <></>}
        {verifyOtpErrorMsg ? <span className='error-validate'>{verifyOtpErrorMsg}</span> : <></>}
      </div>
    </div>
  );
};
